import { Type } from "class-transformer";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumberString, IsOptional, IsString, Matches, MaxLength, ValidateNested } from "class-validator";

export class QaQcData{
    @ApiPropertyOptional()
    qaQcTestId: number;

    @ApiProperty()
    @IsString()
    @IsOptional()
    @MaxLength(5, { message: "Test Code Length Should be less than or Equal to 5" })
    testCode: string;

    @ApiProperty()
    @IsString()
    @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Test Name should be only alpha numeric" })
    @IsNotEmpty()
    @MaxLength(30, { message: "Test Name Length Should be less than or Equal to 30" })
    testName: string;
    
    // @ApiProperty()
    // @IsString()
    // @IsOptional()
    // @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),  { message: "Test Description should be only alpha numeric" })
    // @IsNotEmpty()
    // @MaxLength(30, { message: "Test Description Length Should be less than or Equal to 50" })
    // testDescription: string;


    // @ApiProperty({type: Operations})
    // @ValidateNested({ each: true })
    // @Type(() => Operations)
    // operationInfo: Operations;

    @ApiProperty()
    operationInfo: number;

    @ApiPropertyOptional()
    isActive: boolean;
    createdAt?: Date;
    @ApiProperty()
    createdUser?: string;
    updatedAt?: Date;
    @ApiProperty()
    updatedUser?: string;
    versionFlag?: number;
}